import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bankslist',
  templateUrl: './bankslist.component.html',
  styleUrls: ['./bankslist.component.css']
})
export class BankslistComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
